// The table's cell texts, pure. Every cell of "All blunders" / "All misses"
// keeps to one line: the Score cell shows the scores only, and the standings
// they mean ("Winning → Better") go to its tooltip and its accessible name.
import { STANDING_LABEL } from '@chess/api-mistakes';
import type { MistakeRow } from './MistakesAggregator.ts';

/** A score in pawns from the reader's side: "+3.5", "−1.6", "0.0". */
export const scoreText = (p: number): string => `${p > 0 ? '+' : p < 0 ? '−' : ''}${Math.abs(p).toFixed(1)}`;

/** The Score cell's line: "+3.5 → +1.6". */
export const scoreLine = (m: Pick<MistakeRow, 'before' | 'after'>): string => `${scoreText(m.before)} → ${scoreText(m.after)}`;

/** The standings the scores mean: "Winning → Better". */
export const swingText = (m: Pick<MistakeRow, 'swing'>): string => `${STANDING_LABEL[m.swing.from]} → ${STANDING_LABEL[m.swing.to]}`;

/** The Score cell's tooltip and accessible name: "+3.5 → +1.6, Winning → Better". */
export const scoreTitle = (m: Pick<MistakeRow, 'before' | 'after' | 'swing'>): string => `${scoreLine(m)}, ${swingText(m)}`;
